import { render, staticRenderFns } from "./SLoadFile.vue?vue&type=template&id=a85ebeb8"
import script from "./SLoadFile.vue?vue&type=script&lang=js"
export * from "./SLoadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports